interface MSWProviderProps {
  children: React.ReactNode;
}

// MSW DISABLED - All mock handlers are disabled
// To re-enable mocks, set this to true and uncomment the useEffect below
const ENABLE_MOCKS = false;

export function MSWProvider({ children }: MSWProviderProps) {
  // MSW initialization disabled - using real API calls only
  //
  // To re-enable mocks:
  // 1. Set ENABLE_MOCKS = true above
  // 2. Uncomment the useEffect block below
  //
  // useEffect(() => {
  //   async function init() {
  //     if (ENABLE_MOCKS && import.meta.env.MODE === 'development' && typeof window !== 'undefined') {
  //       try {
  //         console.log('[MSW] Starting initialization...');
  //         const { initMocks } = await import('../../mocks');
  //         await initMocks();
  //         console.log('[MSW] Initialization complete');
  //       } catch (err) {
  //         console.error('[MSW] Failed to initialize:', err);
  //       }
  //     }
  //   }
  //   init();
  // }, []);

  return <>{children}</>;
}
